
import Vue, { PropType } from "vue";

interface InsightItem {
  label: string;
  value: number;
}

export default Vue.extend({
  name: "AiReportInsightsCard",
  props: {
    items: {
      type: Array as PropType<InsightItem[]>,
      required: true
    }
  }
});
